export const env = {
    ...{
        production: false,
        url: 'https://api-dev.ezatca.com/api/',
    }, // any custom env config here
    // --------------------------------------------------------------------
    // base env config here (this imported as separate JS script in index.html)
    ... (window as any).bootstrapConfigSettings
}
